import React from 'react';
import { InputGroup } from 'react-bootstrap';

function Checkbox(props) {
    const handleChange = (value) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    return(
        <InputGroup className="mb-3">
            <InputGroup.Prepend>
                <InputGroup.Text>{props.title}</InputGroup.Text>
                <InputGroup.Checkbox disabled={props.disabled} checked={props.value != undefined ? props.value : (props.defaultValue != undefined ? props.defaultValue : false)} name={props.name} onChange={(evt) => handleChange(evt.target.checked)}/> 
            </InputGroup.Prepend>
        </InputGroup>
    );
}

export default Checkbox;